import { render, staticRenderFns } from "./FooterBar.vue?vue&type=template&id=1ed2beb7&scoped=true&"
var script = {}
import style0 from "./FooterBar.vue?vue&type=style&index=0&id=1ed2beb7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed2beb7",
  null
  
)

export default component.exports